export default __webpack_public_path__ + "static/media/Situ Studio - Logo.e7aa6d9c.png";